import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMentorshipProgramsTotalsQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['Int']['input'];
}>;


export type GetMentorshipProgramsTotalsQuery = { __typename?: 'query_root', mentorshipProgram_aggregate: { __typename?: 'mentorshipProgram_aggregate', aggregate?: { __typename?: 'mentorshipProgram_aggregate_fields', count: number } | null }, mentorshipProgram: Array<{ __typename?: 'mentorshipProgram', id: number, name: string, workspaceId: number, mentorships: Array<{ __typename?: 'mentorship', id: any, mentorId: string, menteeId: string, mentor?: { __typename?: 'users', id: string, fullName?: string | null } | null, mentee?: { __typename?: 'users', id: string, fullName?: string | null } | null }>, mentorships_aggregate: { __typename?: 'mentorship_aggregate', aggregate?: { __typename?: 'mentorship_aggregate_fields', count: number } | null } }> };


export const GetMentorshipProgramsTotalsDocument = gql`
    query getMentorshipProgramsTotals($workspaceId: Int!) {
  mentorshipProgram_aggregate(where: {workspaceId: {_eq: $workspaceId}}) {
    aggregate {
      count
    }
  }
  mentorshipProgram(where: {workspaceId: {_eq: $workspaceId}}) {
    id
    name
    workspaceId
    mentorships {
      id
      mentorId
      mentor {
        id
        fullName
      }
      menteeId
      mentee {
        id
        fullName
      }
    }
    mentorships_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetMentorshipProgramsTotalsQuery__
 *
 * To run a query within a React component, call `useGetMentorshipProgramsTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorshipProgramsTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorshipProgramsTotalsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetMentorshipProgramsTotalsQuery(baseOptions: Apollo.QueryHookOptions<GetMentorshipProgramsTotalsQuery, GetMentorshipProgramsTotalsQueryVariables> & ({ variables: GetMentorshipProgramsTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorshipProgramsTotalsQuery, GetMentorshipProgramsTotalsQueryVariables>(GetMentorshipProgramsTotalsDocument, options);
      }
export function useGetMentorshipProgramsTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorshipProgramsTotalsQuery, GetMentorshipProgramsTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorshipProgramsTotalsQuery, GetMentorshipProgramsTotalsQueryVariables>(GetMentorshipProgramsTotalsDocument, options);
        }
export function useGetMentorshipProgramsTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorshipProgramsTotalsQuery, GetMentorshipProgramsTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorshipProgramsTotalsQuery, GetMentorshipProgramsTotalsQueryVariables>(GetMentorshipProgramsTotalsDocument, options);
        }
export type GetMentorshipProgramsTotalsQueryHookResult = ReturnType<typeof useGetMentorshipProgramsTotalsQuery>;
export type GetMentorshipProgramsTotalsLazyQueryHookResult = ReturnType<typeof useGetMentorshipProgramsTotalsLazyQuery>;
export type GetMentorshipProgramsTotalsSuspenseQueryHookResult = ReturnType<typeof useGetMentorshipProgramsTotalsSuspenseQuery>;
export type GetMentorshipProgramsTotalsQueryResult = Apollo.QueryResult<GetMentorshipProgramsTotalsQuery, GetMentorshipProgramsTotalsQueryVariables>;